import { useEffect } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { LegacyShell } from "@/components/PageShell";
import { ArticleCard, usePublished, setMeta } from "@/components/JournalParts";

export default function Journal() {
  const { t, lang } = useLang();
  const articles = usePublished();

  useEffect(() => {
    window.scrollTo(0, 0);
    return setMeta(
      t("The Journal — Dirty Paws Apothecary", "Le Journal — Dirty Paws Apothecary"),
      t("Field notes on mushrooms, dogs and the Alberta woods, from the keepers of Dirty Paws Apothecary.",
        "Notes de terrain sur les champignons, les chiens et les forêts de l'Alberta, par les gardiens de Dirty Paws Apothecary.")
    );
  }, [t]);

  const [lead, ...rest] = articles || [];

  return (
    <LegacyShell testid="journal-page">
      <main className="max-w-6xl mx-auto px-5 md:px-10 py-20 md:py-28" data-no-translate>
        <p className="font-display italic text-[#B5A642]">{t("Field notes from the house", "Notes de terrain de la maison")}</p>
        <h1 className="mt-3 font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[#E8DDC7]" data-testid="journal-title">
          {t("The Journal", "Le Journal")}
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-[#D3CEC4]/65">
          {t("On mushrooms, dogs and the woods between them. Written slowly, checked twice, and never in a hurry to sell you anything.",
            "Sur les champignons, les chiens et les forêts qui les relient. Écrit lentement, vérifié deux fois, et jamais pressé de vous vendre quoi que ce soit.")}
        </p>
        <div className="hairline mt-12" />
        {articles && articles.length === 0 && (
          <p data-testid="journal-empty" className="mt-16 font-display italic text-2xl text-[#D3CEC4]/50">
            {t("The ink is still drying on the first entry. Do come back.", "L'encre de la première entrée sèche encore. Revenez bientôt.")}
          </p>
        )}
        {lead && (
          <div className="mt-14 grid lg:grid-cols-12 gap-12">
            <div className="lg:col-span-8"><ArticleCard a={lead} lang={lang} large /></div>
            <div className="lg:col-span-4 space-y-12">
              {rest.slice(0, 2).map((a) => <ArticleCard key={a.id} a={a} lang={lang} />)}
            </div>
          </div>
        )}
        {rest.length > 2 && (
          <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
            {rest.slice(2).map((a) => <ArticleCard key={a.id} a={a} lang={lang} />)}
          </div>
        )}
      </main>
    </LegacyShell>
  );
}
